import HelpTooltip from '@/app/common/components/HelpTooltip';
import { guideTooltipHtml } from './CoverageHelpTip';

const INSPECT_QUOTA_GUIDE = {
  matchKey: 'inspect-quota-2000',
  title: 'سهمیه روزانه بازرسی (QPD)',
  paragraphs: [
    'این سقف یک پنجرهٔ متحرک ۲۴ ساعته است، نه ریست در نیمه‌شب. با عوض شدن تاریخ ظرفیت یک‌جا آزاد نمی‌شود؛ هر درخواست حدود ۲۴ ساعت بعد از ارسال دوباره به سهمیه برمی‌گردد.',
    'شمارندهٔ این کارت فقط بازرسی‌های همین پروژه در این سرویس را نشان می‌دهد. سهمیهٔ واقعی گوگل روی همان Property مشترک است: اگر چند نفر یا چند ابزار همان سایت را inspect کنند، سقف ۲۰۰۰تایی بین همه تقسیم می‌شود — نه جدا برای هر کاربر.',
  ],
};

export function InspectQuotaHelpTip() {
  return (
    <HelpTooltip
      html={guideTooltipHtml(INSPECT_QUOTA_GUIDE)}
      placement="top"
      className="ms-1"
    />
  );
}
